import { createWidgetRouter } from "@blockdaemon/widget-host";

import { routeTree } from "./routeTree.gen";

export function createTokenizationRouter() {
  return createWidgetRouter(routeTree);
}
